module.exports = __webpack_public_path__ + "static/media/kw-01-yellow.42db4da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/kw-01-yellow.png
// module id = 7691
// module chunks = 0